(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-contact-guidance]').forEach((guidance) => {
      if (guidance.dataset.ready) return;
      guidance.dataset.ready = 'true';

      const topic = guidance.querySelector('[data-contact-topic]');
      const hint = guidance.querySelector('[data-contact-hint]');
      const params = new URLSearchParams(window.location.search);
      const requestedTopic = Array.from(topic.options).find((option) => option.dataset.topic === params.get('topic'));
      if (!topic.value && requestedTopic) topic.value = requestedTopic.value;

      const updateHint = () => {
        hint.textContent = topic.selectedOptions[0].dataset.guidance;
      };
      topic.addEventListener('change', updateHint);
      updateHint();

      const handle = (params.get('product_handle') || '').trim();
      const title = (params.get('product_title') || '').trim().slice(0, 250);
      // Keep the return link on this storefront, with one encoded path segment.
      if (!handle || handle.length > 255 || !title || /[\s\u0000-\u001f\u007f/\\?#]/u.test(handle) || /^\.+$/.test(handle)) return;

      const product = guidance.querySelector('[data-contact-product]');
      const productInput = guidance.querySelector('[data-contact-product-input]');
      const productUrl = guidance.querySelector('[data-contact-product-url]');
      const link = guidance.querySelector('[data-contact-product-link]');
      const url = new URL(guidance.dataset.productsBase + encodeURIComponent(handle), window.location.origin);
      guidance.querySelector('[data-contact-product-title]').textContent = title;
      link.href = url.href;
      productInput.value = title;
      productUrl.value = url.href;
      productInput.disabled = false;
      productUrl.disabled = false;
      product.hidden = false;

      guidance.querySelector('[data-contact-product-clear]').addEventListener('click', () => {
        productInput.disabled = true;
        productUrl.disabled = true;
        productInput.value = '';
        productUrl.value = '';
        product.hidden = true;
        topic.focus();
      });
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
